var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M6.88323 0.605726C7.26245 -0.0882041 8.25903 -0.088204 8.63826 0.605726L9.72097 2.58693C9.92644 2.96292 10.3486 3.16622 10.7707 3.09244L12.9947 2.70368C13.7737 2.56751 14.395 3.34666 14.0889 4.07581L13.215 6.15757C13.0492 6.55264 13.1534 7.00946 13.4743 7.29344L15.1649 8.78987C15.757 9.314 15.5353 10.2856 14.7744 10.5009L12.6019 11.1156C12.1896 11.2323 11.8975 11.5986 11.8755 12.0265L11.7596 14.2813C11.719 15.071 10.8211 15.5034 10.1784 15.0427L8.34328 13.7275C7.99503 13.4779 7.52646 13.4779 7.1782 13.7275L5.3431 15.0427C4.70034 15.5034 3.80246 15.071 3.76187 14.2813L3.646 12.0265C3.62401 11.5986 3.33186 11.2323 2.91958 11.1156L0.747123 10.5009C-0.0137944 10.2856 -0.235553 9.314 0.356593 8.78987L2.0472 7.29344C2.36804 7.00946 2.4723 6.55264 2.30646 6.15757L1.43255 4.07581C1.12645 3.34666 1.74781 2.56751 2.52679 2.70368L4.75081 3.09244C5.17288 3.16622 5.59505 2.96292 5.80052 2.58693L6.88323 0.605726Z",
    fill: "#44F2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75b4dcc08c3f0f9e9a3fdf954ae4641f.svg";
export { ForwardRef as ReactComponent };